module.exports = __webpack_public_path__ + "media/src/StayPackage/images/plusCircle-4c86073aa4a2fc91366f2f28e72323ef.svg";